<template>
  <div>
    <Head title="Cushions Receipts" />
    <h1 class="mb-8 text-3xl font-bold">Cushions Receipts</h1>

    <div class="bg-white rounded-md shadow mb-5">
      <form @submit.prevent="store" @keydown.enter="$event.preventDefault()"  @keyup.enter="$event.preventDefault()">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pr-8 pl-8 pb-8">
          <div class="pb-2 pr-6 mb-3 w-full lg:w-1/3">
            <Checkbox label="Reworks" :active="is_reworks" @input="is_reworks = $event"/>
          </div>
          <div v-show="!is_reworks" class="w-full lg:w-12/12">
            <text-input
              v-model="form.block_number"
              :error="form.errors.block_number"
              class="pb-6 pr-6 w-full lg:w-full"
              placeholder="Block Number"
            />
          </div>
          <div
            class="pb-2 pr-6 w-full lg:w-full"
          >
            <div
              v-for="(cutting, index) in form.cuttings"
              :key="index"
              class="flex flex-wrap w-full"
            >
              <div class="w-full lg:w-5/12">
                <text-input
                  :key="index"
                  v-model="cutting.quantity"
                  type="number"
                  :error="showValidationErrors(`cuttings.${index}.quantity`)"
                  class="pb-6 pr-6 w-full lg:w-full"
                  placeholder="Quantity"
                />
              </div>
              <div class="w-full lg:w-5/12">
                <text-input
                  :key="index"
                  v-model="cutting.part_number"
                  :error="showValidationErrors(`cuttings.${index}.part_number`)"
                  class="pb-6 pr-6 w-full lg:w-full"
                  placeholder="Scan Part Number"
                />
              </div>
              <div class="pb-2 pr-6 w-full lg:w-2/12">
                <div class="w-full lg:w-1/2">
                  <svg
                    v-show="form.cuttings.length > 1"
                    @click="removeCutting(index, form.cuttings)"
                    xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" style="color: red;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div class="w-full lg:w-1/2">
                  <svg
                    v-show="index === countCuttings"
                    @click="addCutting"
                    xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div
            class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
          >
            <loading-button
              :loading="form.processing"
              class="btn-orange px-3 py-2 text-xs"
              type="submit"
            >
              Add Receipt
            </loading-button>
          </div>
      </form>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Today's Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">All Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-summaryFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-summary-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false">Summaries</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Block Number</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">User</th>
            </tr>
            <tr v-for="item in cushions.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ item.block_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.part_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.user }}
                </Link>
              </td>
            </tr>
            <tr v-if="cushions.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="cushions.links" />
      </div>
      <div class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3"  @reset="reset"/>
          <a
            v-if="search.dateValue && all_cushions.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/cushions/receipts/download${url()}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Block Number</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">User</th>
            </tr>
            <tr v-for="all_cushion in all_cushions.data" :key="all_cushion.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ all_cushion.block_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.part_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center justify-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ all_cushion.user }}
                </Link>
              </td>
            </tr>
            <tr v-if="all_cushions.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="12">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="all_cushions.links" />
      </div>
      <div class="tab-pane fade" id="tabs-summaryFill" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="summary.dateRange" class="mr-0 w-full max-w-md" @reset="resets"/>
          <a
            v-if="summary.dateRange && cushion_summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/cushions/receipts/summaries/download${urlSummary()}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Block Number</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Part Description</th>              
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
            </tr>
            <tr
              v-for="cushion_summary in cushion_summaries.data"
              :key="cushion_summary.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ cushion_summary.block_number }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ cushion_summary.part_number }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ cushion_summary.description }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ cushion_summary.quantity }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ cushion_summary.unit_of_measure }}
                </span>
              </td>
            </tr>
            <tr v-if="cushion_summaries.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="12">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="cushion_summaries.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
//import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DateRange from '@/Shared/DateRange'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import Checkbox from '@/Shared/Checkbox'

export default {
  components: {
    Head,
    //Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Checkbox,
  },
  layout: Layout,
  props: {
    filters: Object,
    cushions: Object,
    all_cushions: Object,
    cushion_summaries: Object,
  },
  data() {
    return {
      is_reworks: false,
      form: this.$inertia.form({
        block_number: null,
        cuttings: [{
          part_number: null,
          quantity: null,
        }],
      }),
      search: {
        dateValue: this.filters.dateValue
      },
      summary: {
        dateRange: this.filters.dateRange
      },
    }
  },
  computed: {
    countCuttings() {
      if (this.form.cuttings.length === 0) {
        return 0;
      }
      return this.form.cuttings.length - 1;
    },
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/cushion-receipts/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summary: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/cushion-receipts/', pickBy(this.summary), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    resets() {
      this.summary = mapValues(this.summary, () => null)
    },
    addCutting(e) {
      e.preventDefault();
      this.form.cuttings.push({
        part_number: null,
        quantity: null,
      });
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return !!error;
      }
      return false;
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return error || '';
      }
      return '';
    },
    store() {
      this.form.transform(({...data }) => ({
        is_reworks: this.is_reworks,
        ...data,
      }))
      this.form.post('/cushion-receipts', {
        onSuccess: () => {
          this.form.reset(
            'cuttings',
            'block_number',
            'is_reworks',
          )
          this.is_reworks = false
        },
      });
    },
    removeCutting(index, cuttings) {
      cuttings.splice(index, 1)
    },
    url() {
      let query = '';
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
    urlSummary() {
      let query = '';
      if (this.summary.dateRange) {
        if (query) {
          query += '&';
        }
        query += `dateRange=${this.summary.dateRange}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
